(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sn-product-info-tabs"] && !Shopify.designMode) return;
  try {
    /* <sn-pi-tabs>: Rebuy glue for the Bundles panel.
     - wait-rebuy: sets rebuy-ready (shows the tab bar) once the Rebuy widget is visible with items; Rebuy hides the
       widget (.is-hidden) when it has no bundle for the product.
     - Rebuy marks off-screen widgets `inert` and only re-checks on window scroll, so the widget rendered in the hidden
       panel would stay unclickable after a tab switch; a scroll event is sent each time the panel is shown. */
  class SnPiTabs extends HTMLElement {
    connectedCallback() {
      this.bundlesPanel = this.querySelector('.sn-pi-tabs__body > :nth-child(2)');
      if (!this.bundlesPanel) return;
      const waitRebuy = this.hasAttribute('wait-rebuy');
      if (waitRebuy) this.updateReady();
      this.observer = new MutationObserver((mutations) => {
        const panelShown = !this.bundlesPanel.hidden && mutations.some((m) => m.target === this.bundlesPanel && m.attributeName === 'hidden');
        if (panelShown) window.dispatchEvent(new Event('scroll'));
        if (waitRebuy) this.updateReady();
      });
      this.observer.observe(this.bundlesPanel, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'hidden'] });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    updateReady() {
      const widget = this.bundlesPanel.querySelector('.rebuy-widget');
      const ready = !!widget?.classList.contains('is-visible') && !!this.bundlesPanel.querySelector('.rebuy-bundle__items > *');
      if (ready === this.hasAttribute('rebuy-ready')) return;
      this.toggleAttribute('rebuy-ready', ready);
      // The bundle went away while its tab was open: go back to the Product tab
      const [productTab, bundlesTab] = this.querySelectorAll('hdt-tab-collection > button');
      if (!ready && bundlesTab?.getAttribute('aria-selected') === 'true') productTab?.click();
    }
  }

  if (!customElements.get('sn-pi-tabs')) customElements.define('sn-pi-tabs', SnPiTabs);
  } catch(e) { console.error(e); }
})();

})();
